import type { ExcalidrawFontFaceDescriptor } from "../Fonts";

// Using Google Fonts CDN for Raleway
export const RalewayFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: "https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaorCIPrCFRuFMBg.woff2",
    descriptors: { style: "normal", weight: "400" },
  },
  {
    uri: "https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaoqCIPrCFRuFMBg.woff2",
    descriptors: { style: "normal", weight: "500" },
  },
  {
    uri: "https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaoyGJPrCFRuFMBg.woff2",
    descriptors: { style: "normal", weight: "600" },
  },
  {
    uri: "https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaoy-JPrCFRuFMBg.woff2",
    descriptors: { style: "normal", weight: "700" },
  },
];